import { Button } from "@/components/ui/button";

/** C25 批1(1.11):分页统一件——收编 loop×3 + debug 的自绘分页。page 从 0 起。 */
export function Pagination({
	page,
	pageCount,
	onChange,
}: {
	page: number;
	pageCount: number;
	onChange: (page: number) => void;
}) {
	if (pageCount <= 1) return null;
	const cur = Math.min(page, pageCount - 1);
	return (
		<div className="flex items-center justify-end gap-3 text-sm">
			<span className="text-text-muted">
				第 {cur + 1} / {pageCount} 页
			</span>
			<Button
				type="button"
				variant="outline"
				size="sm"
				disabled={cur === 0}
				onClick={() => onChange(cur - 1)}
			>
				上一页
			</Button>
			<Button
				type="button"
				variant="outline"
				size="sm"
				disabled={cur >= pageCount - 1}
				onClick={() => onChange(cur + 1)}
			>
				下一页
			</Button>
		</div>
	);
}
